import {useState} from 'react'
import NumberFormat from 'react-number-format';
import { forwardRef } from 'react';

 export function useForm(datosIniciales){
    const [proyectoPlan, setProyectoPlan]=useState(datosIniciales)
    const handleChangeProyecto = e => {
        const {name, value}=e.target
        setProyectoPlan({ ...proyectoPlan, [name]: value }) 
        //console.log(` event ${name} ${value}`)  
        //console.log(JSON.stringify(proyectoPlan))
    }

    

    return{proyectoPlan, setProyectoPlan, handleChangeProyecto}
}

export const localeText={
    // Root
    noRowsLabel: 'Sin registros',
    noResultsOverlayLabel: 'No se encontraron resultados.',
    errorOverlayDefaultLabel: 'Ha ocurrido un error.',
  
    // Density selector toolbar button text
    toolbarDensity: 'Densidad',
    toolbarDensityLabel: 'Densidad',
    toolbarDensityCompact: 'Compacta',
    toolbarDensityStandard: 'Estándar',
    toolbarDensityComfortable: 'Confortable',
  
    // Columns selector toolbar button text
    toolbarColumns: 'Columnas',
    toolbarColumnsLabel: 'Seleccionar columnas',
  
    // Filters toolbar button text
    toolbarFilters: 'Filtros',
    toolbarFiltersLabel: 'Mostrar filtros',
    toolbarFiltersTooltipHide: 'Ocultar',
    toolbarFiltersTooltipShow: 'Mostrar filtros',
    toolbarFiltersTooltipActive: (count) =>
      count !== 1 ? `${count} filtros activos` : `${count} filtro activo`,
  
    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: 'Buscar…',
    toolbarQuickFilterLabel: 'Buscar',
    toolbarQuickFilterDeleteIconLabel: 'Limpiar',
  
    // Export selector toolbar button text
    toolbarExport: 'Exportar',
    toolbarExportLabel: 'Exportar',
    toolbarExportCSV: 'Descargar como CSV',
    toolbarExportPrint: 'Imprimir',
    toolbarExportExcel: 'Descargar como Excel',
  
    // Columns panel text
    columnsPanelTextFieldLabel: 'Encontrar columna',
    columnsPanelTextFieldPlaceholder: 'Título de columna',
    columnsPanelDragIconLabel: 'Reordenar columna',
    columnsPanelShowAllButton: 'Mostrar todas',
    columnsPanelHideAllButton: 'Ocultar todas',
  
    // Filter panel text
    filterPanelAddFilter: 'Agregar filtro',
    filterPanelDeleteIconLabel: 'Borrar',
    filterPanelLinkOperator: 'Operador lógico',
    filterPanelOperators: 'Operador', // TODO v6: rename to filterPanelOperator
    filterPanelOperatorAnd: 'Y',
    filterPanelOperatorOr: 'O',
    filterPanelColumns: 'Columnas',
    filterPanelInputLabel: 'Valor',
    filterPanelInputPlaceholder: 'Valor de filtro',
  
    // Filter operators text
    filterOperatorContains: 'contiene',
    filterOperatorEquals: 'igual',
    filterOperatorStartsWith: 'inicia con',
    filterOperatorEndsWith: 'termina con',
    filterOperatorIs: 'es',
    filterOperatorNot: 'no es',
    filterOperatorAfter: 'es después',
    filterOperatorOnOrAfter: 'a partir de',
    filterOperatorBefore: 'es anterior a',
    filterOperatorOnOrBefore: 'en o antes de',
    filterOperatorIsEmpty: 'está vacío',
    filterOperatorIsNotEmpty: 'no está vacío',
    filterOperatorIsAnyOf: 'cualquiera de',
  
    // Filter values text
    filterValueAny: 'alguno',
    filterValueTrue: 'verdadero',
    filterValueFalse: 'falso',
  
    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuShowColumns: 'Mostrar columnas',
    columnMenuFilter: 'Filtro',
    columnMenuHideColumn: 'Ocultar',
    columnMenuUnsort: 'Sin ordenar',
    columnMenuSortAsc: 'Ordenar ASC',
    columnMenuSortDesc: 'Ordenar DESC',
  
    // Column header text
    columnHeaderFiltersTooltipActive: (count) =>
      count !== 1 ? `${count} filtros activos` : `${count} filtro activo`,
    columnHeaderFiltersLabel: 'Mostrar filtros',
    columnHeaderSortIconLabel: 'Ordenar',
  
    // Rows selected footer text
    footerRowSelected: (count) =>
      count !== 1
        ? `${count.toLocaleString()} renglones seleccionados`
        : `${count.toLocaleString()} renglón seleccionado`,
  
    // Total row amount footer text
    footerTotalRows: 'Total de registros :',
  
    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount) =>
      `${visibleCount.toLocaleString()} de ${totalCount.toLocaleString()}`,
  
    // Checkbox selection text
    checkboxSelectionHeaderName: 'Selección de casillas de verificación',
    checkboxSelectionSelectAllRows: 'Seleccionar todos los registros',
    checkboxSelectionUnselectAllRows: 'Anular selección de todos los registros',
    checkboxSelectionSelectRow: 'Seleccionar registro',
    checkboxSelectionUnselectRow: 'Anular selección de registro',
  
    // Boolean cell text
    booleanCellTrueLabel: 'si',
    booleanCellFalseLabel: 'no',
  
    // Actions cell more text
    actionsCellMore: 'más',
  
    // Column pinning text
    pinToLeft: 'Anclar a la izquierda',
    pinToRight: 'Anclar a la derecha',
    unpin: 'Desanclar',
  
    // Tree Data
    treeDataGroupingHeaderName: 'Grupo',
    treeDataExpand: 'ver hijos',
    treeDataCollapse: 'ocultar hijos',
  
    // Grouping columns
    groupingColumnHeaderName: 'Grupo',
    groupColumn: (name) => `Agrupar por ${name}`,
    unGroupColumn: (name) => `Dejar de agrupar por ${name}`,
  
    // Master/detail
    detailPanelToggle: 'Alternar panel de detalles',
    expandDetailPanel: 'Expandir',
    collapseDetailPanel: 'Contraer',
  
    // Used core components translation keys
    MuiTablePagination: {},
  
    // Row reordering text
    rowReorderingHeaderName: 'Reordenación de filas',
  
    // Aggregation
    aggregationMenuItemHeader: 'Totalización',
    aggregationFunctionLabelSum: 'sum',
    aggregationFunctionLabelAvg: 'avg',
    aggregationFunctionLabelMin: 'min',
    aggregationFunctionLabelMax: 'max',
    aggregationFunctionLabelSize: 'tamaño',
  }

export const NumberFormatMoney = forwardRef(function NumberFormatCustom(props, __) {
    const { ...other } = props;

    return (
        <NumberFormat
            {...other}           
            thousandSeparator
            decimalScale={2}
            isNumericString           
        />
    );
});